import React from "react";

function LoginScreen({ handleLogin }) {
    return (
        <div id="login-div">
            <h1 id="login-header">CAI News Assistant Login</h1>
            <div id="login-button-div">
                <button id="login-button" onClick={handleLogin}>
                    Login with Entra ID
                </button>
            </div>
        </div>
    );
}

export default React.memo(LoginScreen);